module.exports = __webpack_public_path__ + "03_long_gold.1dceda23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_long_gold.png
// module id = hwCv
// module chunks = 0